import React from "react";

class ThankYou extends React.Component {
  render() {
    document.body.classList.remove("inner-page");
    return (
      <section className="p-0">
        <div className="thanks-bg">
          <div className="thank-you">
            <img
              src="https://cdn.illpackus.com/thanks.gif"
              alt=""
              className="img-fluid thank-you-image"
            />
            <h3 className="mb-4">Thanks for joining our early access list!</h3>
            <h3>
              <a
                href={`${process.env.PUBLIC_URL}/`}
                target="_top"
                rel="noopener noreferrer"
              >
                <button className="btn thank-you-button">
                  Back to I'll Pack Us
                </button>
              </a>
            </h3>
          </div>
        </div>
      </section>
    );
  }
}

export default ThankYou;



// WEBPACK FOOTER //
// ./src/pages/thank-you.js